import { useCampaignDetail, useCampaignList } from "../../reuseableEffects";
import CampaignCard from "./campaignCard";
import { useSelector } from "react-redux";
import Spinner from "../../../components/Spinners/Spinner";
import tagSolid from "../../../assets/icons/tag-solid.svg";
import { Link } from "react-router-dom";
import SkeletonCard from "../../../components/skeletonCampaignCard";
import { useEffect, useState } from "react";

const RecommendedCampaigns = () => {
  const campaignImageURL = "https://mosquepay.org/mosquepaynew/assets/img/campaigns/";

  const campaignList = useCampaignList();

  const [randomCampaigns, setRandomCampaigns] = useState([]);
  const [filterType, setFilterType] = useState("random"); // "random", "top", "struggling"

  const shuffleCampaigns = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  const calculateProgress = (campaign) => {
    const formattedAmountRaised = parseFloat(campaign?.amount_raise?.replace(/,/g, "")) || 0;
    const formattedAmount = parseFloat(campaign?.amount?.replace(/,/g, "")) || 0;
    return formattedAmount > 0 ? (formattedAmountRaised / formattedAmount) * 100 : 0;
  };

  const getFilteredCampaigns = (campaigns, type) => {
    const activeCampaigns = campaigns.filter(campaign => campaign.admin_status === "0");
    
    switch (type) {
      case "top":
        return activeCampaigns
          .sort((a, b) => calculateProgress(b) - calculateProgress(a))
          .slice(0, 4);
      case "struggling":
        return activeCampaigns
          .sort((a, b) => calculateProgress(a) - calculateProgress(b))
          .slice(0, 4);
      case "random":
      default:
        return shuffleCampaigns([...activeCampaigns]).slice(0, 4);
    }
  };

  useEffect(() => {
    if (campaignList.length > 0) {
      const filteredCampaigns = getFilteredCampaigns(campaignList, filterType);
      setRandomCampaigns(filteredCampaigns);
    }
  }, [campaignList, filterType]);

  // Gratitude challenge
  const gratitudeCampaignID = "2024102814064837049426404";
  const campaignDetail = useCampaignDetail(gratitudeCampaignID);

  const loading = useSelector((state) => state.user.loading);

  const formattedAmountRaised = parseFloat(campaignDetail?.amount_raise?.replace(/,/g, "")) || 0;
  const formattedAmount = parseFloat(campaignDetail?.amount?.replace(/,/g, "")) || 0;

  const percentage =
    formattedAmount > 0
      ? `${((formattedAmountRaised / formattedAmount) * 100).toFixed(2)}%`
      : "0%";

  const getDropdownLabel = () => {
    switch (filterType) {
      case "top":
        return "Top 4 campaigns";
      case "struggling":
        return "Struggling campaigns";
      case "random":
      default:
        return "Causes you can donate to";
    }
  };

  return (
    <div>
      <Spinner loading={useSelector((state) => state.user).loading} />
      {loading ? (
        <SkeletonCard />
      ) : (
        <div className="py-4 px-4 md:px-12 grid gap-4">
          <div className="flex items-center justify-between md:justify-normal">
            {/* <p className="font-semibold text-sm ubuntu-font mb-1">
              <span>{getDropdownLabel()}:</span>
            </p> */}
            <div className="relative">
              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
                className="opacity-0 absolute inset-0 w-full h-full cursor-pointer"
              >
                <option value="random">Causes you can donate to</option>
                <option value="top">Top 4 campaigns</option>
                <option value="struggling">Struggling campaigns</option>
              </select>
              <button className="bg-white text-sm focus:outline-none focus:border-transparent flex items-center gap-1 pointer-events-none">
                <p className="font-semibold text-sm ubuntu-font mb-[2px]">
                  <span>{getDropdownLabel()}:</span>
                </p>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.0575 13.859C9.00917 13.8119 8.8025 13.6342 8.6325 13.4685C7.56333 12.4976 5.81333 9.96473 5.27917 8.63902C5.19333 8.43769 5.01167 7.92868 5 7.65672C5 7.39613 5.06 7.14771 5.18167 6.91066C5.35167 6.61516 5.61917 6.37811 5.935 6.24821C6.15417 6.1646 6.81 6.03471 6.82167 6.03471C7.53917 5.90481 8.705 5.83337 9.99333 5.83337C11.2208 5.83337 12.3392 5.90481 13.0675 6.01116C13.0792 6.02334 13.8942 6.15323 14.1733 6.2953C14.6833 6.55589 15 7.06491 15 7.60964V7.65672C14.9875 8.01149 14.6708 8.75755 14.6592 8.75755C14.1242 10.0118 12.46 12.4862 11.3542 13.4807C11.3542 13.4807 11.07 13.7608 10.8925 13.8826C10.6375 14.0725 10.3217 14.1667 10.0058 14.1667C9.65333 14.1667 9.325 14.0604 9.0575 13.859"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-4">
            <div className="grid gap-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-10">
                {randomCampaigns.map((row, index) => {
                  const formattedAmountRaised =
                    parseFloat(row?.amount_raise?.replace(/,/g, "")) || 0;
                  const formattedAmount =
                    parseFloat(row?.amount?.replace(/,/g, "")) || 0;
                  const progress =
                    formattedAmount > 0
                      ? `${(
                          (formattedAmountRaised / formattedAmount) *
                          100
                        ).toFixed(2)}%`
                      : "0%";

                  return (
                    <CampaignCard
                      key={index}
                      campaignImage={
                        campaignImageURL + (row?.image || "default-image.png")
                      }
                      campaignID={row?.CampaignID}
                      email={row?.email}
                      campaignTitle={row?.title}
                      campaignOwnerFirstName={row?.firstname}
                      campaignOwnerLastName={row?.lastname}
                      amountRaised={row?.amount_raise}
                      campaignGoal={row?.amount}
                      category={row?.category}
                      progress={progress}
                    />
                  );
                })}
              </div>
              <Link
                to={"/all-campaigns"}
                className="bg-black text-white text-center md:w-fit text-sm font-medium py-6 px-8 md:py-4 rounded"
              >
                View all campaigns
              </Link>
            </div>
            {/* gratitude challenge */}
            <Link
              to={`/campaign-detail/${gratitudeCampaignID}`}
              className="gap-4 md:gap-2 flex flex-col justify-between"
            >
              <div className="flex-grow overflow-hidden rounded relative">
                <img
                  src={
                    campaignImageURL +
                    (campaignDetail?.image || "default-image.png")
                  }
                  alt="campaign_image"
                  className="lg:absolute lg:inset-0 lg:h-full w-full aspect-square lg:aspect-auto object-cover rounded hover:scale-105 transition-transform duration-1000"
                />
              </div>
              <div>
                <p className="truncate font-medium text-sm">
                  {campaignDetail?.title}
                </p>
                <p className="text-sm text-secondary truncate">
                  <span>Campaign owner:</span> <span>Mosquepay Limited</span>
                </p>
                <div className="grid gap-1 mt-3">
                  <div className="w-full rounded-md bg-secondaryBackground p-[2px] flex items-center">
                    <div
                      className="bg-brandGreen h-[2px] transition-all"
                      style={{ width: percentage }}
                    ></div>
                  </div>
                  <p className="text-sm text-secondary truncate">
                    &#8358;{campaignDetail?.amount_raise} raised out of &#8358;
                    {campaignDetail?.amount}
                  </p>
                </div>
                <div className="mt-2 flex items-center gap-2">
                  <img src={tagSolid} alt="" className="h-4" />
                  <span className="text-[13px] text-secondary">
                    {campaignDetail?.campaign_category}
                  </span>
                </div>
              </div>
              <div className="bg-white text-white text-sm md:py-4 rounded md:mt-8 cursor-default">
                {/* Do not delete this div */}.
              </div>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecommendedCampaigns;